const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	quizzes : [],
	current_quiz : null,
	current_quiz_submits : [],
	current_quiz_submits_student : null,
}

const getters = {
	fetchQuizzes : (state) => state.quizzes,
	fetchCurrentQuiz : (state) => state.current_quiz,
	fetchNewQuiz : (state) => state.new_quiz,
	fetchQuizSubmits : (state) => state.current_quiz_submits,
	fetchQuizSubmitsStudent : (state) => state.current_quiz_submits_student,
}

const actions = {
	//Load all quizmasters
	loadQuizzes({commit}, token){
		return $http.get('quiz', {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_QUIZZES', response.data)
		})
	},

	//Load a single quiz
	loadQuizDetails({commit}, {quiz_id, token}){
		return $http.get(`quiz/${quiz_id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_QUIZ', response.data)
		})
	},

	// Load all submits of a quiz
	loadQuizSubmits({commit}, {quiz_id, token}){
		return $http.get(`quiz/${quiz_id}/submit`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_QUIZ_SUBMITS', response.data)
		})
	},

	//Load quiz submission/responses of a particular student
	loadStudentQuizSubmits({commit}, {quiz_id, user_id, token}){
		return $http.get(`quiz/${quiz_id}/submitone?userid=${user_id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_QUIZ_SUBMITS_STUDENT', response.data)
		})
	},

	//Create new quiz master
	createQuizResponse({commit}, {response, token}){
		return $http.post('/quizresponse', response, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_QUIZ', response.data)
		})
	},

	//Create new quiz master
	updateQuiz({commit}, {quiz_id, quiz, token}){
		return $http.put(`/quiz/${quiz_id}`, quiz, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			const result = response.data
			commit('UPDATE_QUIZ', result)
		})
	},

	//QUiz maunual submission
	manualSubmitQuiz({commit}, {token, quiz_id, submission}){
		return $http.post(`/quiz/${quiz_id}/submit/manual`, submission, {
            headers: {
                'x-auth-token': token
            }
        }).then(res => {
            commit('MANUAL_QUIZ_SUBMIT', res.data)
        })
	},


	//Delete Quizzes
	deleteQuizzes({commit}, {quizzes, token}){
		return $http.delete('/quiz', {
			headers : {
				'x-auth-token' : token
			},
			data : {
				quizzes
			}
		}).then(() => {
			commit('REMOVE_QUIZZES', quizzes)
		})	
	},

	//Mark a question manually
	markQuestionManually({commit}, {quiz_id, token, vals}){
		return $http.put(`/quiz/${quiz_id}?markquestion=true`, vals, {
			headers : {
				'x-auth-token' : token
			},
		}).then((response) => {
			commit('UPDATE_QUESTION_MANUALLY', {
				response : response.data,
				qindex : vals.qindex,
				sindex : vals.sindex
			})
		})		
	},

	//Publish quiz results
	publishQuizResults({commit}, {quiz_id, publish, token}){
		return $http.put(`/quiz/${quiz_id}?publish_manipulate=true`, {publish}, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			const result = response.data
			commit('UPDATE_QUIZ_PUBLISHED', result)
		})
	}

}

const mutations = {
	SET_QUIZZES : (state, all_quizzes) => {
		state.quizzes = all_quizzes
	},

	SET_CURRENT_QUIZ_SUBMITS : (state, submits) => {
		state.current_quiz_submits = submits
	},

	SET_CURRENT_QUIZ_SUBMITS_STUDENT : (state, submits) => {
		state.current_quiz_submits_student = submits
	},

	UPDATE_QUESTION_MANUALLY : (state, {response, qindex, sindex}) => {
		state.current_quiz_submits_student.submission[sindex].questions[qindex].marks = response.marks	
	},

	REMOVE_QUIZZES : (state, quizzes) => {
		state.quizzes = state.quizzes.filter(quiz_obj => !quizzes.includes(quiz_obj._id))
	},

	SET_CURRENT_QUIZ : (state, quiz) => {
		state.current_quiz = quiz
	},

	ADD_QUIZ : (state, qm) => {
		state.quizzes.push(qm)
	},

	UPDATE_QUIZ : (state, quiz) => {
		state.current_quiz = quiz
	},

	UPDATE_QUIZ_PUBLISHED : (state, quiz_published_status) => {
		state.current_quiz.isResultsPublished = quiz_published_status
	},

	MANUAL_QUIZ_SUBMIT : (state, submission) => {
		state.current_quiz_submits.push(submission)
	}
}

export default { 
	state, getters, actions, mutations
}